import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {SelectValueInterface} from '@interfaces/select-value.interface';

/**
 * Типы собственности оборудоания
 */

@Injectable()
export class EquipmentLeasedTypeProvider {
    public data$ = new BehaviorSubject<SelectValueInterface[]>([
        {id: 0, title: 'Собственное'},
        {id: 1, title: 'Арендованое'},
    ]);
}
